import { DeviceManifest } from '@rapoo/device-sdk'
import {
  cafe54MouseConfig,
  cafeMouseMacro,
  dpi45kStepped,
  inputReportCybercafe,
  mousePerfCap,
  parametersLiftoffLow,
} from './generate/capabilityPresets'

/**
 * ESM672MAX 设备清单
 **/
const rapooESM672MAX: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESM672MAX',
  mainControl: 'ESM672MAX',
  type: 'mouse',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x4640],
    currentPid: 0x4640,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 2,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 14,
        description: 'Only update Firmware',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Only update WCH Firmware',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'VT_nrf54L',
  MCU: 'N54L05',
  sensor: 'PAW3950U',
  microSwitch: 'mechanical',
  encoder: 'mechanical',
  battery: 800,
  ui: {
    assetsDir: 'manifests/ESM672MAX',
    colors: {
      series: [
        {
          name: 'common.products.ESM672MAX.Gray_Black_Red',
          value: '#2B2B2B',
          key: 'Gray_Black_Red',
        },
        {
          name: 'common.products.ESM672MAX.Black_Gray_Orange',
          value: '#FFA458',
          key: 'Black_Gray_Orange',
        },
        {
          name: 'common.products.ESM672MAX.White_Black_Yellow',
          value: '#E1F049',
          key: 'White_Black_Yellow',
        },
        {
          name: 'common.products.ESM672MAX.Black_Purple_Green',
          value: '#7131C9',
          key: 'Black_Purple_Green',
        },
        {
          name: 'common.products.ESM672MAX.Black_Gray_Green',
          value: '#9CEA60',
          key: 'Black_Gray_Green',
        },
      ],
      current: 'Gray_Black_Red',
    },
    icon: 'Hardware-Wireframe-Mouse',
    overview: true,
  },
  capabilities: [
    inputReportCybercafe,
    cafe54MouseConfig,
    parametersLiftoffLow,
    dpi45kStepped,
    cafeMouseMacro,
    mousePerfCap({ tier: 'cybercafe', sensorScanRateLabel: '13K' }),
  ],
  layout: {
    keys: [
      [
        {
          key: 0,
          keywords: '左击',
          x: -25,
          y: 50,
          alignLeft: false,
          url: 'mouse left',
        },
        {
          key: 1,
          keywords: '中键',
          x: 240,
          y: 52,
          alignLeft: true,
          url: 'roller middle',
        },
        {
          key: 2,
          keywords: '右击',
          x: 240,
          y: 156,
          alignLeft: true,
          url: 'mouse right',
        },
        {
          key: 3,
          keywords: 'DPI+',
          x: 240,
          y: 208,
          alignLeft: true,
          url: 'dpi+',
        },
        {
          key: 4,
          keywords: 'DPI-',
          x: 240,
          y: 260,
          alignLeft: true,
          url: 'dpi-',
        },
        {
          key: 5,
          keywords: '右侧',
          x: -25,
          y: 132,
          alignLeft: false,
          url: 'mouse forward',
        },
        {
          key: 6,
          keywords: '左侧',
          x: -25,
          y: 195,
          alignLeft: false,
          url: 'mouse back',
        },
        {
          key: 9,
          keywords: '上滚',
          x: 240,
          y: 0,
          alignLeft: true,
          url: 'roller up',
        },
        {
          key: 10,
          keywords: '下滚',
          x: 240,
          y: 104,
          alignLeft: true,
          url: 'roller down',
        },
        {
          key: 13,
          keywords: 'DIY',
          x: 655,
          y: 118,
          alignLeft: true,
          url: 'diy',
        },
      ],
    ],
  },
}

export default rapooESM672MAX
